export default __webpack_public_path__ + "static/media/food04.c4024e1c.png";